import React, {useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export default function SimplePopover(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);


  const handleClick = (event) => {
    if(props.clicked!=undefined){props.clicked();}
    if(props.block_click==true){event.stopPropagation(); event.preventDefault();}
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    console.log(e, 'EEE');
    if(props.block_click==true){e.stopPropagation(); e.preventDefault();}
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <span style={(props.style!=undefined)?props.style:{position:'relative'}}>
      <span onClick={handleClick}>{props.trigger}</span>
      <Popover
        id={id}
        open={(props.force_close==true)?false:open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical:'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical:'center',
          horizontal: 'left',
        }}
      >
        {props.content}
      </Popover>
    </span>
  );
}
